export default __webpack_public_path__ + "static/media/slider-smc360-1.b10caa9c.jpg";